import * as actionTypes from './actionTypes';

const initialState = {
  pendingRoleIdsBySpaceId: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PENDING_ROLE_IDS_SUCCESS:
      return {
        ...state,
        pendingRoleIdsBySpaceId: {
          ...state.pendingRoleIdsBySpaceId,
          [action.spaceId]: action.ids,
        },
      };
    case actionTypes.CONFIRM_ROLE_AUDIT_SUCCESS:
      return {
        ...state,
        pendingRoleIdsBySpaceId: {
          ...state.pendingRoleIdsBySpaceId,
          [action.spaceId]: state.pendingRoleIdsBySpaceId[action.spaceId]
            .filter((id) => id !== action.roleId),
        },
      };
    default:
      return state;
  }
};
